import PatrolPlansTable from '@/app/patrol-plans'
import { ability } from '@/casl/ability'
import TableSkeleton from '@/components/table-skeleton'
import { getFirstAccessibleRoute } from '@/constants/Auth'
import { patrolsByCompanyIdQueryOptions } from '@/hooks/usePatrolsQuery'
import LocalStorage from '@/utilities/LocalStorage'
import { createFileRoute, redirect } from '@tanstack/react-router'

const RouteComponent = () => {
  return <PatrolPlansTable />
}

export const Route = createFileRoute('/_auth/_withProject/patrol-plans')({
  beforeLoad: ({ context }) => {
    if (
      ability &&
      context.auth.user &&
      !ability.can('read', 'Devriye Planları')
    ) {
      const permissions = context.auth.user.permissions || []
      const redirectPath = getFirstAccessibleRoute(permissions)
      throw redirect({
        to: redirectPath,
      })
    }
  },
  loader: async ({ context }) => {
    const { queryClient } = context

    const companyId = LocalStorage.selectedCompany()?.id

    await queryClient.prefetchQuery(patrolsByCompanyIdQueryOptions(companyId))
    return {}
  },
  pendingComponent: TableSkeleton,
  component: RouteComponent,
})


